import "./style.less";
export default function AccountNav() {
    return {
        restrict: "E",
        scope: {
            active: "<",
        },
        template: require("./template.html"),

        controller: function ($scope) {
            $scope.accountNav = [
                {
                    name: "profile",
                    title: "Profil",
                    href: "account/profile",
                },
                {
                    name: "bookings",
                    title: "Bookinger",
                    href: "account/bookings",
                },
            ];
        },
    };
}
